// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file entitlements/v3/features.proto (package entitlements.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v3_common } from "../../common/v3/common_pb";

/**
 * Describes the file entitlements/v3/features.proto.
 */
export const file_entitlements_v3_features: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v3_common]);

/**
 * Feature enumerates the capabilities available within the platform.
 * The enum values are organized into logical groupings with reserved number
 * ranges, allowing for systematic expansion of feature sets while maintaining
 * clear organizational boundaries.
 *
 * Features are made available through entitlements.
 *
 * @generated from enum entitlements.v3.Feature
 */
export enum Feature {
  /**
   * Default unspecified value. Should not be used directly.
   *
   * @generated from enum value: FEATURE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Enables diagnostic tools and information for system troubleshooting.
   * Provides access to UI tooling and other debugging interfaces.
   *
   * @generated from enum value: FEATURE_DIAGNOSTICS = 1;
   */
  DIAGNOSTICS = 1,

  /**
   * Allows administrators to impersonate other users for testing and support.
   * Enables verification of user-specific behaviors without credential sharing.
   *
   * @generated from enum value: FEATURE_PROXY_AS = 2;
   */
  PROXY_AS = 2,

  /**
   * Enables creation and management of organizational knowledge.
   * Provides tools for ingesting, organizing, and retrieving information.
   *
   * @generated from enum value: FEATURE_KNOWLEDGE_BASE = 10;
   */
  KNOWLEDGE_BASE = 10,

  /**
   * Enables creation, editing, and sharing of persistent content artifacts.
   * Provides version control and collaborative editing capabilities.
   *
   * @generated from enum value: FEATURE_ARTIFACTS = 100;
   */
  ARTIFACTS = 100,

  /**
   * Enables connections to third-party tools and data sources.
   * Provides authentication and data exchange capabilities
   * with external systems.
   *
   * @generated from enum value: FEATURE_INTEGRATIONS = 200;
   */
  INTEGRATIONS = 200,

  /**
   * Enables programmatic access to platform capabilities via APIs, SDKs,
   * and RPC interfaces.
   *
   * @generated from enum value: FEATURE_API_ACCESS = 300;
   */
  API_ACCESS = 300,

  /**
   * Enables projects for organizing knowledge, actions, and chats within
   * a workspace.
   *
   * @generated from enum value: FEATURE_PROJECTS = 400;
   */
  PROJECTS = 400,

  /**
   * Enables creation and management of isolated user or team workspaces.
   * Provides boundaries for data access and sharing permissions.
   *
   * @generated from enum value: FEATURE_WORKSPACES = 500;
   */
  WORKSPACES = 500,

  /**
   * Enables creation and management of user groups with shared permissions.
   * Provides collaboration tools and team-level resource allocation.
   *
   * @generated from enum value: FEATURE_TEAMS = 600;
   */
  TEAMS = 600,

  /**
   * Enables creation and management of organizational structures and policies.
   * Provides enterprise-wide settings, billing, and administrative controls.
   *
   * @generated from enum value: FEATURE_ORGANIZATIONS = 700;
   */
  ORGANIZATIONS = 700,

  /**
   * Enables creation and application of labels for organizing and filtering content.
   * Provides taxonomy management and hierarchical classification.
   *
   * @generated from enum value: FEATURE_LABELS = 800;
   */
  LABELS = 800,

  /**
   * Enables subscription to specific topics or channels for receiving
   * updates and notifications such as when a concept changes, an action
   * performs an analysis, or an insight is learned.
   *
   * @generated from enum value: FEATURE_SUBSCRIPTIONS = 900;
   */
  SUBSCRIPTIONS = 900,

  /**
   * Enables discovery and management of unified ideas formed from the
   * knowledge base.
   *
   * @generated from enum value: FEATURE_CONCEPTS = 1000;
   */
  CONCEPTS = 1000,

  /**
   * Enables automatic discovery of concepts from knowledge assets.
   *
   * @generated from enum value: FEATURE_CONCEPT_AUTO_DISCOVERY = 1001;
   */
  CONCEPT_AUTO_DISCOVERY = 1001,

  /**
   * Enables creation and management of reusable actions and workflows.
   *
   * @generated from enum value: FEATURE_ACTIONS = 100000;
   */
  ACTIONS = 100000,

  /**
   * Enables scheduling of actions to run at specific times or intervals.
   *
   * @generated from enum value: FEATURE_ACTION_SCHEDULING = 100001;
   */
  ACTION_SCHEDULING = 100001,

  /**
   * Enables actions to be automatically triggered based on specific
   * events or conditions.
   *
   * @generated from enum value: FEATURE_ACTION_AUTO_TRIGGERS = 100003;
   */
  ACTION_AUTO_TRIGGERS = 100003,

  /**
   * Enables standard, real-time inference mode for chat interactions.
   * Provides immediate responses optimized for conversational flow.
   *
   * @generated from enum value: FEATURE_CHAT_STYLE_DIRECT_INFERENCE = 500000;
   */
  CHAT_STYLE_DIRECT_INFERENCE = 500000,

  /**
   * Enables enhanced thinking mode with more comprehensive reasoning.
   * Provides deeper analysis and more thorough responses at the cost of latency.
   *
   * @generated from enum value: FEATURE_CHAT_STYLE_DELIBERATIVE_INFERENCE = 500001;
   */
  CHAT_STYLE_DELIBERATIVE_INFERENCE = 500001,

  /**
   * Enables text-based input for initiating and continuing conversations.
   * Provides standard typing interface for user prompts and queries.
   *
   * @generated from enum value: FEATURE_CHAT_PROMPT_WITH_TEXT = 501000;
   */
  CHAT_PROMPT_WITH_TEXT = 501000,

  /**
   * Enables audio input for initiating and continuing conversations.
   * Provides speech-to-text capabilities for voice interaction.
   *
   * @generated from enum value: FEATURE_CHAT_PROMPT_WITH_AUDIO = 501002;
   */
  CHAT_PROMPT_WITH_AUDIO = 501002,

  /**
   * Enables customization of prompt templates and system instructions.
   * Provides tools for defining reusable conversation starters.
   *
   * @generated from enum value: FEATURE_CHAT_PROMPT_PERSONALIZATION = 501003;
   */
  CHAT_PROMPT_PERSONALIZATION = 501003,

  /**
   * Enables user-specific adaptations in conversation style and content.
   * Provides preference management for tailoring interactions to individual users.
   *
   * @generated from enum value: FEATURE_CHAT_PERSONALIZATION = 502000;
   */
  CHAT_PERSONALIZATION = 502000,

  /**
   * Enables enhanced visualizations to supplement text responses.
   * Provides charts, graphs, and other visual elements to enrich conversations.
   *
   * @generated from enum value: FEATURE_CHAT_TOOL_VISUALIZATIONS = 502001;
   */
  CHAT_TOOL_VISUALIZATIONS = 502001,

  /**
   * Enables web search capabilities within chat interactions using OpenAI's
   * web search tool. Provides access to real-time information from the web.
   *
   * @generated from enum value: FEATURE_WEB_SEARCH_OPEN_AI_GPT41 = 502002;
   */
  WEB_SEARCH_OPEN_AI_GPT41 = 502002,

  /**
   * Enables web search capabilities for tools.
   * Provides access to real-time web search through Exa API.
   *
   * @generated from enum value: FEATURE_TOOL_WEB_SEARCH = 502003;
   */
  TOOL_WEB_SEARCH = 502003,

  /**
   * Enables web page fetch capabilities for tools.
   * Provides access to fetch and parse web pages through Exa API.
   *
   * @generated from enum value: FEATURE_TOOL_WEB_PAGE = 502004;
   */
  TOOL_WEB_PAGE = 502004,

  /**
   * Enables image generation capabilities for tools.
   * Provides access to DALL-E, Gemini Imagen, and Banana image generation.
   *
   * @generated from enum value: FEATURE_TOOL_IMAGE_GENERATION = 502005;
   */
  TOOL_IMAGE_GENERATION = 502005,

  /**
   * Enables knowledge base search capabilities for tools.
   * Provides access to search across uploaded knowledge assets.
   *
   * @generated from enum value: FEATURE_TOOL_KB_SEARCH = 502006;
   */
  TOOL_KB_SEARCH = 502006,

  /**
   * Enables document generation capabilities for tools.
   * Provides access to generate downloadable reports in Markdown and PDF formats.
   *
   * @generated from enum value: FEATURE_TOOL_DOCUMENT_GENERATION = 502007;
   */
  TOOL_DOCUMENT_GENERATION = 502007,

  /**
   * Enables access to Storytell ruleset model.
   * Provides a ruleset model for Storytell.
   *
   * @generated from enum value: FEATURE_MODEL_STORYTELL_RULESET = 1000000;
   */
  MODEL_STORYTELL_RULESET = 1000000,

  /**
   * Enables story-tell to automatically select the best model for the task.
   *
   * @generated from enum value: FEATURE_MODEL_STORYTELL_AUTO_SELECT = 1000001;
   */
  MODEL_STORYTELL_AUTO_SELECT = 1000001,

  /**
   * Enables access to Storytell curated model selection.
   * Provides curated model recommendations based on task requirements.
   *
   * @generated from enum value: FEATURE_MODEL_STORYTELL_CURATED = 1000002;
   */
  MODEL_STORYTELL_CURATED = 1000002,

  /**
   * @generated from enum value: FEATURE_MODEL_STORYTELL_AGENT_V3 = 1000003;
   */
  MODEL_STORYTELL_AGENT_V3 = 1000003,

  /**
   * Enables access to Anthropic Claude 3.5 Sonnet model.
   * Provides balanced performance across reasoning, creativity, and speed.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_35_SONNET = 1100000;
   */
  MODEL_ANTHROPIC_CLAUDE_35_SONNET = 1100000,

  /**
   * Enables access to Anthropic Claude 3.7 Sonnet model.
   * Provides enhanced capabilities over the 3.5 version with improved reasoning.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_37_SONNET = 1100001;
   */
  MODEL_ANTHROPIC_CLAUDE_37_SONNET = 1100001,

  /**
   * Enables access to Anthropic Claude 3.7 Sonnet Thinking model.
   * Provides enhanced reasoning with explicit thinking process.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_37_SONNET_THINKING = 1100002;
   */
  MODEL_ANTHROPIC_CLAUDE_37_SONNET_THINKING = 1100002,

  /**
   * Enables access to Anthropic Claude 4 Sonnet model.
   * Provides the latest capabilities with improved performance.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_4_SONNET = 1100003;
   */
  MODEL_ANTHROPIC_CLAUDE_4_SONNET = 1100003,

  /**
   * Enables access to Anthropic Claude 4 Sonnet Thinking model.
   * Provides the latest capabilities with explicit thinking process.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_4_SONNET_THINKING = 1100004;
   */
  MODEL_ANTHROPIC_CLAUDE_4_SONNET_THINKING = 1100004,

  /**
   * Enables access to Anthropic Claude 4.5 Sonnet model.
   * Provides enhanced capabilities with improved reasoning and performance.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_45_SONNET = 1100005;
   */
  MODEL_ANTHROPIC_CLAUDE_45_SONNET = 1100005,

  /**
   * Enables access to Anthropic Claude 4.6 Sonnet model.
   * Provides the latest capabilities with improved reasoning and 64K output tokens.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_46_SONNET = 1100006;
   */
  MODEL_ANTHROPIC_CLAUDE_46_SONNET = 1100006,

  /**
   * Retired: Claude Haiku 4.5 is no longer served or selectable. The value stays
   * because messages served before the retirement still carry it.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_45_HAIKU = 1100007;
   */
  MODEL_ANTHROPIC_CLAUDE_45_HAIKU = 1100007,

  /**
   * Enables access to Anthropic Claude 4.6 Opus model.
   * Provides the most capable model with superior reasoning and analysis.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_46_OPUS = 1100008;
   */
  MODEL_ANTHROPIC_CLAUDE_46_OPUS = 1100008,

  /**
   * Enables access to Anthropic Claude Opus 4.8 model.
   * Provides the most capable Opus-tier model for long-horizon agentic work.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_48_OPUS = 1100009;
   */
  MODEL_ANTHROPIC_CLAUDE_48_OPUS = 1100009,

  /**
   * Retired: Claude Sonnet 5 is no longer served or selectable. The value stays
   * because messages served before the retirement still carry it.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_5_SONNET = 1100010;
   */
  MODEL_ANTHROPIC_CLAUDE_5_SONNET = 1100010,

  /**
   * Retired: Claude Fable 5 is no longer served or selectable. The value stays
   * because messages served before the retirement still carry it.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_5_FABLE = 1100011;
   */
  MODEL_ANTHROPIC_CLAUDE_5_FABLE = 1100011,

  /**
   * Retired: Claude Opus 5 is no longer served or selectable. The value stays
   * because messages served before the retirement still carry it.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_5_OPUS = 1100012;
   */
  MODEL_ANTHROPIC_CLAUDE_5_OPUS = 1100012,

  /**
   * Enables access to Anthropic Claude Opus 5.5 model.
   * Provides deep reasoning and long-horizon agentic work at Opus-tier cost.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_55_OPUS = 1100013;
   */
  MODEL_ANTHROPIC_CLAUDE_55_OPUS = 1100013,

  /**
   * Enables access to Anthropic Claude Haiku 5.5 model.
   * Provides fast, lightweight inference optimized for low-latency use cases.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_55_HAIKU = 1100014;
   */
  MODEL_ANTHROPIC_CLAUDE_55_HAIKU = 1100014,

  /**
   * Enables access to Anthropic Claude Sonnet 5.5 model.
   * Provides near-Opus quality on coding and agentic work at Sonnet cost.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_55_SONNET = 1100015;
   */
  MODEL_ANTHROPIC_CLAUDE_55_SONNET = 1100015,

  /**
   * Enables access to OpenAI GPT-4.1 model.
   * Provides their flagship large language model with comprehensive capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_41 = 1200000;
   */
  MODEL_OPENAI_GPT_41 = 1200000,

  /**
   * Enables access to OpenAI GPT-4.1 Mini model.
   * Provides a smaller, faster variant with reduced capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_41_MINI = 1200001;
   */
  MODEL_OPENAI_GPT_41_MINI = 1200001,

  /**
   * Enables access to OpenAI GPT-4.1 Nano model.
   * Provides the smallest, fastest variant optimized for low-latency use cases.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_41_NANO = 1200002;
   */
  MODEL_OPENAI_GPT_41_NANO = 1200002,

  /**
   * Enables access to OpenAI o3 model.
   * Provides specialized capabilities for specific use cases.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_03 = 1200003;
   */
  MODEL_OPENAI_03 = 1200003,

  /**
   * Enables access to OpenAI o4 Mini model.
   * Provides efficient performance for lighter workloads.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_04_MINI = 1200004;
   */
  MODEL_OPENAI_04_MINI = 1200004,

  /**
   * Enables access to OpenAI GPT-5 model.
   * Provides next-generation large language model with advanced capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_5 = 1200005;
   */
  MODEL_OPENAI_GPT_5 = 1200005,

  /**
   * Enables access to OpenAI GPT-5 Mini model.
   * Provides a balanced variant optimized for cost-efficiency.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_5_MINI = 1200006;
   */
  MODEL_OPENAI_GPT_5_MINI = 1200006,

  /**
   * Enables access to OpenAI GPT-5 Nano model.
   * Provides a lightweight variant optimized for speed and low-latency.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_5_NANO = 1200007;
   */
  MODEL_OPENAI_GPT_5_NANO = 1200007,

  /**
   * Enables access to OpenAI GPT-5.2 model.
   * Provides next-generation capabilities with improved reasoning and performance.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_52 = 1200008;
   */
  MODEL_OPENAI_GPT_52 = 1200008,

  /**
   * Enables access to OpenAI GPT-5.4 model.
   * Provides next-generation capabilities with improved reasoning and performance.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_54 = 1200009;
   */
  MODEL_OPENAI_GPT_54 = 1200009,

  /**
   * Retired: GPT-5.4 Mini is no longer served or selectable. The value stays
   * because messages served before the retirement still carry it.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_54_MINI = 1200010;
   */
  MODEL_OPENAI_GPT_54_MINI = 1200010,

  /**
   * Retired: GPT-5.4 Nano is no longer served or selectable. The value stays
   * because messages served before the retirement still carry it.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_54_NANO = 1200011;
   */
  MODEL_OPENAI_GPT_54_NANO = 1200011,

  /**
   * Retired: GPT-5.5 is no longer served or selectable. The value stays
   * because messages served before the retirement still carry it.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_55 = 1200012;
   */
  MODEL_OPENAI_GPT_55 = 1200012,

  /**
   * Enables access to OpenAI GPT-6 Astra model.
   * Provides OpenAI's flagship model for the most demanding reasoning and agentic work.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_6_ASTRA = 1200013;
   */
  MODEL_OPENAI_GPT_6_ASTRA = 1200013,

  /**
   * Enables access to OpenAI GPT-6 Sol model.
   * Provides strong reasoning on demanding tasks at mid-tier cost.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_6_SOL = 1200014;
   */
  MODEL_OPENAI_GPT_6_SOL = 1200014,

  /**
   * Enables access to OpenAI GPT-6 Luna model.
   * Provides efficient, low-latency responses at scale.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_6_LUNA = 1200015;
   */
  MODEL_OPENAI_GPT_6_LUNA = 1200015,

  /**
   * Enables access to Google Gemini 2.0 Flash Lite model.
   * Provides lightweight, high-speed inference optimized for real-time applications.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_20_FLASH_LITE = 1300000;
   */
  MODEL_GOOGLE_GEMINI_20_FLASH_LITE = 1300000,

  /**
   * Enables access to Google Gemini 2.5 Pro model.
   * Provides enhanced reasoning and multimodal capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_25_PRO = 1300001;
   */
  MODEL_GOOGLE_GEMINI_25_PRO = 1300001,

  /**
   * Enables access to Google Gemini 2.5 Flash model.
   * Provides fast inference with enhanced capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_25_FLASH = 1300002;
   */
  MODEL_GOOGLE_GEMINI_25_FLASH = 1300002,

  /**
   * Enables access to Google Gemini 2.5 Flash Thinking model.
   * Provides fast inference with explicit thinking process.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_25_FLASH_THINKING = 1300003;
   */
  MODEL_GOOGLE_GEMINI_25_FLASH_THINKING = 1300003,

  /**
   * Enables access to Google Gemini 3.0 Pro model.
   * Provides next-generation capabilities with improved reasoning and multimodal processing.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_30_PRO = 1300004;
   */
  MODEL_GOOGLE_GEMINI_30_PRO = 1300004,

  /**
   * Enables access to Google Gemini 2.5 Flash-Lite model.
   * Provides lightweight, fast inference without reasoning for simple tasks.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_25_FLASH_LITE = 1300005;
   */
  MODEL_GOOGLE_GEMINI_25_FLASH_LITE = 1300005,

  /**
   * Enables access to Google Gemini 3.0 Flash model.
   * Provides fast inference with next-generation capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_30_FLASH = 1300006;
   */
  MODEL_GOOGLE_GEMINI_30_FLASH = 1300006,

  /**
   * Enables access to Google Gemini 3.1 Pro model.
   * Provides advanced reasoning and multimodal capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_31_PRO = 1300007;
   */
  MODEL_GOOGLE_GEMINI_31_PRO = 1300007,

  /**
   * Enables access to Google Gemini 3.1 Flash-Lite model.
   * Lightweight variant for fast inference without reasoning.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_31_FLASH_LITE = 1300008;
   */
  MODEL_GOOGLE_GEMINI_31_FLASH_LITE = 1300008,

  /**
   * Enables access to Google Gemini 3.5 Flash model.
   * Provides Google's most intelligent model for agentic and coding tasks.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_35_FLASH = 1300009;
   */
  MODEL_GOOGLE_GEMINI_35_FLASH = 1300009,

  /**
   * Enables access to Meta Llama 3 70B Versatile model.
   * Provides a general-purpose model with balanced capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_META_LLAMA_3370B_VERSATILE = 1400000;
   */
  MODEL_META_LLAMA_3370B_VERSATILE = 1400000,

  /**
   * Enables access to Meta Llama 4 Scout model.
   * Provides specialized capabilities for exploration and discovery tasks.
   *
   * @generated from enum value: FEATURE_MODEL_META_LLAMA_4_SCOUT = 1400001;
   */
  MODEL_META_LLAMA_4_SCOUT = 1400001,

  /**
   * Enables access to Meta Llama 4 Maverick model.
   * Provides advanced capabilities for complex reasoning tasks.
   *
   * @generated from enum value: FEATURE_MODEL_META_LLAMA_4_MAVERICK = 1400002;
   */
  MODEL_META_LLAMA_4_MAVERICK = 1400002,

  /**
   * Enables access to DeepSeek R1 Distill Llama 70B model.
   * Provides a distilled version with efficient performance characteristics.
   *
   * @generated from enum value: FEATURE_MODEL_DEEPSEEK_R1_DISTILL_LLAMA_70B = 1500000;
   */
  MODEL_DEEPSEEK_R1_DISTILL_LLAMA_70B = 1500000,

  /**
   * Enables access to DeepSeek R1 Distill Qwen 7B model.
   * Provides a smaller, efficient distilled version.
   *
   * @generated from enum value: FEATURE_MODEL_DEEPSEEK_R1_DISTILL_QWEN_7B = 1500001;
   */
  MODEL_DEEPSEEK_R1_DISTILL_QWEN_7B = 1500001,

  /**
   * Enables access to DeepSeek V4 Flash, reached through the OpenRouter gateway.
   * Provides an efficiency-tier model with a 1M-token context window.
   *
   * @generated from enum value: FEATURE_MODEL_DEEPSEEK_V4_FLASH = 1500002;
   */
  MODEL_DEEPSEEK_V4_FLASH = 1500002,
}

/**
 * Describes the enum entitlements.v3.Feature.
 */
export const FeatureSchema: GenEnum<Feature> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_features, 0);

